import { Component, ViewEncapsulation, OnInit, OnDestroy } from '@angular/core';
import { FormControl, FormGroup, FormBuilder, Validators } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';
import { ActivatedRoute } from '@angular/router';
import { ISubscription } from 'rxjs/Subscription';

import { NetworkService } from '../../core/services/network.service';
import { LanguageService } from '../../core/services/language.service';
import { PasswordValidation }    from '../../utils/password-validation.util';

@Component({
  selector: 'password-recovery',
  templateUrl: './password-recovery.component.html',
  styleUrls: ['./password-recovery.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class PasswordRecoveryComponent implements OnInit, OnDestroy {
  subscription: ISubscription;
  title: string = 'RECOVERY.TITLE';
  form: FormGroup;
  token: string;

  constructor (private networkService: NetworkService,
               private toastr: ToastrService,
               private languageService: LanguageService,
               private fb: FormBuilder,
               private router: Router,
               private route: ActivatedRoute) {}

  ngOnInit () {
    this.subscription = this.route.fragment.subscribe(token => {
      this.token = token;
    });

    this.form = this.fb.group({
      email: ['', Validators.email],
      password: ['', [Validators.minLength(6), Validators.required]],
      passwordConfirmation: ['', [Validators.minLength(6), Validators.required]]
    }, {
      validator: PasswordValidation.MatchPassword
    });
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

  get email () {
    return this.form.get('email');
  }

  get password () {
    return this.form.get('password');
  }

  get passwordConfirmation () {
    return this.form.get('passwordConfirmation');
  }

  hasError(model:FormControl) {
    return model.invalid && (model.dirty || model.touched)
  }

  markAsDirty () {
    const controls = this.form.controls;

    for (let control in controls) {
      if (
          controls.hasOwnProperty(control) &&
          controls[control].invalid
      ) {
        controls[control].markAsDirty();
      }
    }
  }

  submitForm ($event) {
    $event.preventDefault();

    if (this.form.invalid) {
      return this.markAsDirty();
    }
    const body = this.form.getRawValue();
    body['token'] = this.token;

    if(!body['token']) {
      this.toastr.error(this.languageService.translate('MESSAGES.RESET_PASSWORD_MISTAKE'), 'Error');
    } else {
      this.networkService
          .resetPassword(body)
          .then(response => {
            this.router.navigate(['/']);
            this.toastr.success(this.languageService.translate('MESSAGES.RESET_PASSWORD_SUCCESS'), 'Success');
          })
          .catch(err => {
            this.toastr.error(err.error.message, 'Error');
          });
    }
  }
}


// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/(IGH Projects)/jobs/EVFS PROD_FRONTEND granima.de/workspace/frontend/src/app/pages/password-recovery/password-recovery.component.ts